import { configureStore } from "@reduxjs/toolkit";

import telegramReducer from "./telegramSlice";

const store = configureStore({
  reducer: {
    telegram: telegramReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
